import { useEffect } from "react"

const useNavigationBlocker = (when?: () => boolean | undefined) => {
  useEffect(() => {
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      if (when?.()) {
        e.preventDefault()
      }
    }
    window.addEventListener("beforeunload", onBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload)
    }
  }, [when])
}

export { useNavigationBlocker }
